import ToursCheckoutScreen from '../(tabs)/tours/checkout'
import { seedToursCheckout } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewCheckoutRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursCheckout} seedKey="checkout">
      <ToursCheckoutScreen />
    </PreviewSeedBoundary>
  )
}
